import React from 'react';
import { getTranslation } from '../../../utils/translation';
import classNames from 'classnames';
import styles from './Account.module.scss';

const Account = props => {
    const { terminalCode } = props;
    return (
        <div className={styles.account}>
            <i className={classNames('icon-user', styles.userIcon)} />
            <span>
                Terminal
                {': '}
                <span className={styles.terminalCode}>{terminalCode}</span>
            </span>
        </div>
    );
};

export default Account;
